import { render, staticRenderFns } from "./Billing_Project.vue?vue&type=template&id=3ab1f140&"
import script from "./Billing_Project.vue?vue&type=script&lang=js&"
export * from "./Billing_Project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports